const restoreEquipments = {
  toastr: 'Equipo restaurado',
  toastr1: 'Equipo restaurado con éxito'
};

export default restoreEquipments;